<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div
      class="tab-pane fade active show"
      id="searchControl-content"
      role="tabpanel"
      aria-labelledby="searchControl-tab"
    >
      <div class="container-fluid">
        <div class="col-sm-12 col-md-12 bd-callout bg-white">
          <div
            class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2"
          >
            <div class="col">
              <div class="modal-header">
                <div class="modal-title h5 text-primary fw-bold mb-4 mb-sm-0">
                  年度國定假日
                </div>
              </div>
              <div class="d-flex flex-wrap justify-content-start justify-content-sm-end align-items-center mb-3 ">
                <p class="align-middle me-2 fw-bold fs-6  mb-3 mb-sm-0">
                  年度行事曆匯入
                </p>
                <div class="col-12 col-sm-5 align-middle me-2 mb-3 mb-sm-0">
                  <input
                    class="form-control"
                    type="file"
                    id="holidayCSV"
                    ref="fileInput"
                  />
                </div>
                <button class="btn btn-primary btn-sm mb-3 mb-sm-0 " @click="checkFormat">
                  確認匯入
                </button>
              </div>
              <div class="">
                <div class="bd-example table-scrollbar">
                  <table id="holidayListTable" :class="tableStyle">
                    <thead class="table-dark mt-4 pt-4">
                      <tr>
                        <th scope="col" width="5%">#</th>
                        <th scope="col" class="text-center">國定假日</th>
                        <th scope="col" class="text-center">日期</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, key) in holidayList"
                        :key="key"
                        :class="tableCenterStyle"
                      >
                        <td>{{ key + 1 }}</td>
                        <td>{{ item.memo }}</td>
                        <td>{{ getDateTime(item.date) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,

      startTime: moment().startOf("day").format(),
      endTime: moment().format(),
      recentYear: moment().startOf("year").year(), //得到今年年份

      holidayList: [],
    };
  },

  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },

    getDateTime(date) {
      return moment(date).format("YYYY/MM/DD");
    },

    getYearHoliday() {
      //取出為指定國定假日且符合當年份的值並排序日期

      const nationalHolidays = this.holidays.filter(
        (item) =>
          item.memo !== "" && moment(item.date).year() === this.recentYear
      );

      nationalHolidays.sort(function (a, b) {
        return moment(a.date).diff(moment(b.date));
      });

      this.holidayList = nationalHolidays;
    },

    initTable: function () {
      this.table = $("#holidayListTable").DataTable({
        aoColumns: [
          ...new Array($("#holidayListTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 15,
        scrollX: true
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },

    //檢查匯入檔案檔名
    async checkFormat() {
      const file = this.$refs.fileInput.files[0];
      if (!Utils.isEmptyObject(file)) {
        const fileType = file.type.split("/")[1];

        if (fileType === "csv") {
          this.uploadCSV();
        } else {
          alert("請上傳正確檔案");
        }
      } else {
        alert("請上傳檔案");
      }
    },

    async uploadCSV() {
      const formData = new FormData();
      formData.append("file", this.$refs.fileInput.files[0]);
      const response = await this.$store.dispatch(
        "holidaySetting/postHolidays",
        formData
      );
      if (response.success) {
        alert("匯入成功");
        //匯入成功時，重新取得國定假日資料，並重新載入datatable資料
        await this.$store.dispatch("holidaySetting/getHolidays");
        
        this.updateTable();
      
      } else {
        alert("上傳失敗，請再試一次或連繫管理人員");
      }
    },
  },
  computed: {
    ...mapGetters("holidaySetting", { holidays: "getHolidays" }),
  },

  watch: {
    holidays: {
      async handler(newVal) {
        this.getYearHoliday();
      },
      immediate: true,
    },
  },

  mounted() {
    this.updateTable();
  },
};
</script>
<style >
/* .table-scrollbar{
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch; 

} */


#holidayListTable_filter{
  margin-bottom: 10px ;

}


</style>